var chunkToChildrenMap = {
	"2704": [
		5911,
		7055,
		5514,
		5990,
		9957,
		9563,
		5105,
		8553,
		5469,
		2419,
		2308,
		6455,
		7541,
		1461,
		3633,
		2101,
		9090,
		7762,
		5766,
		1238,
		3910
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));